export const FILL_STYLE = {
  pickable: false,
  stroked: true,
  filled: true,
  lineWidthMinPixels: 2,
  getFillColor: d => {
    const color = colorStringToArray(d.properties.fillColor);
    return [...color, 255];
  },
  getLineColor: [0, 0, 0, 255],
  getLineWidth: 1
};
export const OUTLINE_STYLE = {
  ...FILL_STYLE
};
export const LABEL_STYLE = {
  getText: d => d.properties.name,
  textSizeUnits: 'common',
  getTextSize: 0.0008,
  textFontFamily: 'Roboto Regular, Inter, Helvetica, sans-serif',
  getTextColor: [32, 33, 36, 255]
};
export const SYMBOL_STYLE = {
  pickable: false,
  stroked: true,
  filled: true,
  pointType: 'circle',
  lineWidthScale: 20,
  lineWidthMinPixels: 2,
  getPointRadius: 15,
  pointRadiusUnits: 'pixels',
  getLineWidth: 1,
  getFillColor: [0, 0, 0, 200],
  getLineColor: [0, 0, 0, 255]
};
const HEX_REGEX = /^#([A-Fa-f0-9]{3}){1,2}$/;
const RGB_REGEX = /^rgba?\([\s]*(\d+)[\s]*,[\s]*(\d+)[\s]*,[\s]*(\d+),?([^,\s)]+)?/;
function colorStringToArray(hex) {
  let c;
  if (Array.isArray(hex)) {
    return hex;
  }
  if (hex != null) {
    if (HEX_REGEX.test(hex)) {
      c = hex.substring(1).split('');
      if (c.length === 3) {
        c = [c[0], c[0], c[1], c[1], c[2], c[2]];
      }
      c = `0x${c.join('')}`;
      return [c >> 16 & 255, c >> 8 & 255, c & 255];
    }
    if (RGB_REGEX.test(hex)) {
      const [, r, g, b] = RGB_REGEX.exec(hex);
      return [parseInt(r), parseInt(g), parseInt(b)];
    }
  }
  return [255, 255, 255, 0];
}